import { environment } from '$environments/environment'
import { LoginDTO, RegisterDTO, User } from '$types'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { StorageService } from './storage.service'

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  // user$: Subject<User | undefined> = new Subject();
  // user: User | null = null;
  constructor(
    private http: HttpClient,
    private readonly storageService: StorageService
  ) { }

  get user(): User | null {
    return this.storageService.getUser();
  }

  hasWatchedPopup(version:string):boolean{
    return this.storageService.hasWatchedPopup(version)
  }
  setHaveWatchedPopup(version:string):void{
    this.storageService.setHaveWatchedPopup(version)
  }


  isLogged(): boolean {
    const user = this.storageService.getUser()

    return !!user.id
  }

  login(data: LoginDTO): Observable<any> {

    const email: string = data.email,
      password: string = data.password

    return this.http.post(
      environment.apiUrl + '/rest/signin',
      {
        email,
        password,
      },
      {
        withCredentials: true,
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      }
    );
  }
  register(data: RegisterDTO): Observable<any> {

    return this.http.post(
      environment.apiUrl + '/rest/signup',data,
      httpOptions
    );
  }

  signupFinish(token: string, mail: string): Observable<any> {

    return this.http.put(
      environment.apiUrl + '/rest/signup-finish/'+token + '?mail='+mail,{},
      httpOptions
    );
  }

  logout() {
    this.storageService.clean()
    window.location.reload();
  }

  sendResetEmail(email: string): Observable<any> {
    const forgotPasswordRequest = { email };

    return this.http.post(
      environment.apiUrl + '/rest/forgot-password',
      forgotPasswordRequest,
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      }
    );
  }


}
